import { gql } from '@apollo/client';

export const ADD_GEOGRAPHY_TO_PROGRAMME = gql`
  mutation addGeographyToProgramme($input: AddGeographyToProgrammeInput!) {
    geography: addGeographyToProgramme(input: $input) {
      id
    }
  }
`;
